import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import ProductBookingReeducer from '../store/ProductBooking/productBookingSlice';
import airlineReducer from '../store/airlineData/airlineDataSlice';
import dashboardReducer from '../store/dashboard/dasboardSlice';
import flightReducer from '../store/flight/flightSlice';
import optionsReducer from '../store/options/optionsSlice';
import publicDataReeducer from '../store/publicData/publicDataSlice';
import tierReducer from '../store/tiers/tiersSlice';
import userInfoReducer from '../store/userInfo/userInfoSlice';
export const store = configureStore({
  reducer: {
    flight: flightReducer,
    options: optionsReducer,
    userInfo: userInfoReducer,
    dashboard: dashboardReducer,
    tiers: tierReducer,
    airline: airlineReducer,
    publicData: publicDataReeducer,
    ProductBooking: ProductBookingReeducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
